import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import type { SiteControllerSettingNeppanFormModel } from "@/components/features/settings/site-controller/model/neppan/type";
import type { SiteControllerSettingNeppanFormModelMethodsType } from "@/components/features/settings/site-controller/model/neppan/use-case/use-create-model/methods";

import { InputPasswordField } from "@/components/ui/form/fields/input-field/input-password";

type Props = {
	hotelID: SiteControllerSettingNeppanFormModel["ViewModel"]["hotelID"]; //
	password: SiteControllerSettingNeppanFormModel["ViewModel"]["password"]; //
	onSetPassword: SiteControllerSettingNeppanFormModelMethodsType["siteControllerSettingNeppanFormModelMethods"]["onSetPassword"];
};

export const SettingsSiteControllerNeppanPassword = ({ hotelID, password, onSetPassword }: Props) => {
	return (
		<QuestionForMain
			guide="パスワードは、CHILLNNのログインパスワードとは異なるパスワードを自由に設定が可能です。<br />表示されているIDと設定したパスワードをご利用のサイトコントローラーに登録しましょう。"
			required={true}
			title={"パスワード"}
			inputChildren={
				<div className="space-y-4">
					<div>
						<p>ログインID</p>
						<p className="font-semibold">{hotelID}</p>
					</div>
					<InputPasswordField
						label="パスワード"
						className="w-full xl:w-1/2"
						value={password?.value}
						errorMessage={password?.error}
						onChange={onSetPassword}
					/>
				</div>
			}
		/>
	);
};

SettingsSiteControllerNeppanPassword.displayName = "SettingsSiteControllerNeppanPassword";
